import { Grid, List, TextField } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import * as documentService from "../../../models/services/documentService";
import { Dialog } from "../../framework/Dialog/Dialog";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { IFolderTreeNode } from "source/models/document/folderTreeNode";
import { DocumentTreeFolderNode } from "../DocumentFolders/DocumentFolderTreeNode";
import { useEffect } from "react";
import { FileType } from "ui/Scripts/source/models/enums";
import { DocumentFolders } from "source/models/document/documentFolders";

interface IDocumentSelectDialogProp {
    companyId: string;
    onGetDocumentFoldersAndDocuments?: (companyId: string) => Promise<DocumentFolders>;
    onOk: (folderTreeNode: IFolderTreeNode, documentFullPath: string) => void;
    onCancel: () => void;
}

interface IDocumentSelectDialogState {
    initialized: boolean;
    folderTreeNodes: IFolderTreeNode[];
    folderTree: IFolderTreeNode;
    selectedFolderId: string;
    documentFolderTreeNode: IFolderTreeNode;
    documentFullPath: string;
}

export const DocumentSelectDialog = (props: IDocumentSelectDialogProp) => {
    const [state, setState] = React.useState<IDocumentSelectDialogState>({
        initialized: false,
        folderTreeNodes: [],
        folderTree: null,
        selectedFolderId: "",
        documentFolderTreeNode: null,
        documentFullPath: "",
    });

    const loadData = async () => {
        const getDocumentFoldersAndDocuments = props.onGetDocumentFoldersAndDocuments || documentService.getDocumentFoldersAndDocuments;
        const result = await AppUtils.callService(() => getDocumentFoldersAndDocuments(props.companyId), false);
        if (!result) {
            setState(old => ({
                ...old,
                initialized: true,
            }));
            return;
        }
        const folderTreeNodes = result.folderTree.getAsList([]);
        setState(old => ({
            ...old,
            initialized: true,
            folderTree: result.folderTree,
            folderTreeNodes,
            selectedFolderId: result.folderTree.id,
        }));
    };

    useEffect(() => {
        loadData();
    }, [props.companyId]);

    const handleFolderNodeClick = (aNode: IFolderTreeNode) => {
        const folderTreeNodes = state.folderTreeNodes.slice(0);
        const node = folderTreeNodes.find(i => i.id === aNode.id);
        if (!node) return;
        if (node.parent) {
            node.expanded = !node.expanded;
        }
        setState(old => ({
            ...old,
            folderTreeNodes,
            selectedFolderId: aNode.id
        }));
    };

    const handleDocumentNodeClick = (aNode: IFolderTreeNode) => {
        setState((old) => ({
            ...old,
            documentFolderTreeNode: aNode,
            documentFullPath: aNode.getFullPath(),
        }));
    };

    const handleNodeClick = (aNode: IFolderTreeNode) => {
        if (!aNode?.id) return;
        if (aNode.fileType === FileType.Document) {
            handleDocumentNodeClick(aNode);
        } else {
            handleFolderNodeClick(aNode);
        }
    };

    const handleOk = () => {
        if (!state.documentFolderTreeNode) return;
        props.onOk(state.documentFolderTreeNode, state.documentFullPath);
    };

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Dialog
            id="documentSelectDialog"
            maxWidth="md"
            title={Translations.SelectDocument}
            body={
                <GridRow>
                    <Grid item sm={12}>
                        <FormField title={Translations.SelectedDocument} fullWidth margin={0}>
                            <TextField
                                name="code"
                                title={state.documentFullPath}
                                value={state.documentFullPath}
                                disabled={true}
                                size="small"
                                fullWidth
                            />
                        </FormField>
                        <FormField title={Translations.Folders} fullWidth margin=".5rem 0 0 0">
                            <div style={{ maxHeight: "calc(100vh - 420px", overflowY: "auto", overflowX: "hidden" }}>
                                <List>
                                    {state.folderTreeNodes.map((node, index) =>
                                        <DocumentTreeFolderNode
                                            key={node.id}
                                            sessionState={null}
                                            companyId={props.companyId}
                                            editMode={false}
                                            node={node}
                                            selectedId={state.selectedFolderId}
                                            isFirstNode={index < 1}
                                            onClick={handleNodeClick}
                                        />
                                    )}
                                </List>
                            </div>
                        </FormField>
                    </Grid>
                </GridRow>
            }
            buttons={[
                { title: Translations.Cancel, variant: "outlined", onClick: handleCancel },
                { title: Translations.OK, variant: "confirmation", onClick: handleOk, disabled: !state.documentFolderTreeNode },
            ]}
            onClose={handleCancel}
        />
    );
};